import { Box, Grid, makeStyles, Typography } from "@material-ui/core";
import React from "react";

import { ImageType } from "../../../images/svg";
import SectionButton from "../components/SectionButton";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";

const useStyles = makeStyles((theme) => ({
  title: {
    fontFamily: "Montserrat, sans-serif",
    fontSize: "24px",
    fontWeight: 700,
    color: "#114668",
    alignSelf: "center",
  },
  box: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

const commandCard = (
  index,
  classes,
  title,
  description,
  image,
  onClick,
  eklok,
) => {
  console.log("image", image);
  return (
    <Grid item xs={6} key={index}>
      <Box className={classes.box}>
        <SectionButton
          title={title}
          description={description}
          image={image}
          onClick={() => onClick(eklok)}
        />
      </Box>
    </Grid>
  );
};

const CommandListView = ({ type, commands, eklokData }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const classes = useStyles();

  console.log("commands", commands);

  const images = {
    ACTIONS: { image: ImageType.Routine },
    MUSICS: { image: ImageType.Music },
    MELODIES: { image: ImageType.Melodies },
    MUSICS_SYNTH: { image: ImageType.MusicsSynth },
  };

  const commandsTypeText = {
    ACTIONS: t("mobile_frame.home.routines"),
    MUSICS: t("mobile_frame.home.musics"),
    MELODIES: t("mobile_frame.home.melodies"),
    MUSICS_SYNTH: t("mobile_frame.home.musicsSynth"),
  };

  return (
    <>
      <Typography className={classes.title}>{eklokData.name}</Typography>
      <Typography className={classes.title}>
        {t("mobile_frame.home." + type)}
      </Typography>
      <Grid container rowspacing={3} columnspacing={{ xs: 1, sm: 2, md: 3 }}>
        {commands.map((command, index) => {
          console.log("command", command);
          const image = images[command.ACTION_TYPE]?.image
            ? images[command.ACTION_TYPE].image
            : ImageType.Favorites;
          const commandTypeText = commandsTypeText[command.ACTION_TYPE]
            ? commandsTypeText[command.ACTION_TYPE]
            : "";
          return commandCard(
            index,
            classes,
            command.ACTION_NAME,
            commandTypeText,
            image,
            () => {
              history.push(
                "/app/command/" + command.ACTION_ID + "/" + eklokData.id,
              );
            },
            eklokData.id,
          );
        })}
      </Grid>
      {commands.length === 0 && (
        <Box className={classes.box}>
          <Typography className={classes.textLightBig}>
            {t("mobile_frame.home.no_action_present")}
          </Typography>
          <Box className={classes.break} />
        </Box>
      )}
    </>
  );
};

export default CommandListView;
